import { SignUp } from "@clerk/react";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button } from "@/components/ui/button";
import { routes } from "@/routes";

export function SignupAsClub() {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  return (
    <div>
      <Button
        variant="ghost"
        className="absolute left-2 top-2 text-neutral-300 no-underline"
        onClick={() => navigate(routes.signup)}
      >
        <ArrowLeft />
        {t("common:back")}
      </Button>

      <SignUp
        signInUrl={routes.signin}
        fallbackRedirectUrl={routes.onboarding}
        unsafeMetadata={{ role: "club" }}
      />
    </div>
  );
}
